import React, { useEffect, useState } from "react";
import { graphcms, QUERY_ABOUT_US } from "../Graphql/Queries";
import { Helmet } from "react-helmet-async";
import { Skeleton } from "@/components/ui/skeleton";

import ieee_logo from "img/logos/ieee-logo.png";
import cis_logo from "img/logos/cis-logo.png";
import ieee_sb_logo from "img/logos/IEEE_SB_Logo.png";
import cis_sb_logo from "img/logos/CIS_SB_Logo_1.png";

function About() {
  const [pdf, setPdf] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // About us api data
    graphcms.request(QUERY_ABOUT_US).then((res) => {
      setPdf(res.aboutUs.membershipStatistics.url);
      setLoading(false);
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>About Us - IEEE CIS SBC UoJ</title>
        <meta
          name="description"
          content="Learn about the IEEE CIS Student Branch Chapter at the University of Jaffna, our mission, vision, and the team dedicated to advancing computational intelligence."
        />
        <link rel="canonical" href="https://cis.jfn.ac.lk/about" />
      </Helmet>

      <div className="container mb-32 mx-auto">
        <div>
          <div className="w-full flex flex-col lg:flex-row gap-5 items-center justify-between px-10 my-10">
            <a
              href="https://www.ieee.org"
              target="_blank"
              rel="noopener noreferrer">
              <img src={ieee_logo} alt="IEEE Logo" width={200} />
            </a>
            <a
              href="https://cis.ieee.org"
              target="_blank"
              rel="noopener noreferrer">
              <img src={cis_logo} alt="IEEE CIS Logo" width={150} />
            </a>
            <a
              href="http://society.jfn.ac.lk/ieee"
              target="_blank"
              rel="noopener noreferrer">
              <img
                src={ieee_sb_logo}
                alt="IEEE Student branch UoJ Logo"
                width={125}
              />
            </a>
            <a
              href="https://cis.jfn.ac.lk"
              target="_blank"
              rel="noopener noreferrer">
              <img
                src={cis_sb_logo}
                alt="IEEE CIS Student branch UoJ Logo"
                width={250}
              />
            </a>
          </div>
          <h1 className="text-3xl font-extrabold text-center mb-8">ABOUT US</h1>
          <p className="text-base w-11/12 lg:w-10/12 text-justify m-auto indent-20">
            Welcome to the IEEE Computational Intelligence Society (CIS) Student
            Branch Chapter at the University of Jaffna, Sri Lanka. We are a
            dynamic group of aspiring professionals dedicated to promoting
            technological development and fostering a collaborative environment
            for the advancement of computational intelligence. As the first CIS
            chapter in Sri Lanka, we take pride in leading the way and setting a
            high standard for excellence. Building upon the foundation laid by
            our predecessors, we strive to foster a thriving community that
            encourages intellectual growth and promotes interdisciplinary
            collaboration among students, researchers, and industry
            professionals. Our mission is to facilitate the development of
            skills and expertise in computational intelligence, empowering our
            members to tackle complex real-world challenges and make a positive
            impact on society. By organizing engaging events, educational
            programs, and industry collaborations, we provide a platform for
            individuals to explore their passion for computational intelligence
            and transform their ideas into reality.
          </p>
          <p className="text-base w-11/12 lg:w-10/12 text-justify m-auto indent-20">
            We welcome students from various disciplines who share a common
            interest in computational intelligence and its applications.
            Together, let us embark on a transformative journey, where
            innovation meets collaboration, and knowledge paves the way for a
            brighter future. Join us today and be a part of the IEEE CIS Student
            Branch Chapter at the University of Jaffna, where the possibilities
            are limitless.
          </p>
        </div>
        <div className="my-10">
          <h1 className="text-3xl font-extrabold text-center mb-8">VISION</h1>
          <p className="text-base w-11/12 lg:w-10/12 text-justify m-auto indent-20">
            Empowering students to become skilled leaders in the dynamic field
            of computational intelligencethrough inclusive education, skill
            building, fostering teamwork, creativity and ethical leadership and
            nature the next generation of innovators, while building a diverse
            community of passionate leaders.
          </p>
        </div>
        <div className="my-10">
          <h1 className="text-3xl font-extrabold text-center mb-8">MISSION</h1>
          <p className="text-base w-11/12 lg:w-10/12 text-justify m-auto indent-20">
            To promote and advance nature-inspired computational paradigms in
            science and engineering amoung students through education,
            collaboration and practical applications, fostering innovation and
            positive societal impact.
          </p>
        </div>
        <div className="my-10">
          <h1 className="text-3xl font-extrabold text-center mb-8">
            IEEE OU ANALYTICS
          </h1>
          {loading ? (
            <Skeleton className="mx-auto h-[20rem] lg:h-[50rem] w-[80%] rounded-xl" />
          ) : (
            <embed
              src={pdf}
              type="application/pdf"
              frameBorder="0"
              scrolling="auto"
              height="100%"
              width="80%"
              className="mx-auto h-[20rem] lg:h-[50rem]"></embed>
          )}
        </div>
      </div>
    </>
  );
}

export default About;
